<template>
  <main>
    <div class="container">
      <div class="main-content-box">
        <div class="top-page-divider">
          <h3 class="page-title center">Frequently Asked Questions</h3>
        </div>
        <div class="row">
          <div class="col-12 col-md-8 col-lg-9">
            <hr id="1">
            <h5 class="paragraph--heading">Do I need a website acount to play Xalor?</h5>
            <p><strong>Yes</strong> registration is required to login. This not only keeps your account secure, but also makes it easier to recover your password should you ever forget it!</p>
            <hr id="2">
            <h5 class="paragraph--heading">How do I report a bug?</h5>
            <p>Bugs found in game or the website are handled in our forums on the <a href="https://discord.com/channels/1367631511951769672/1396689178271682632" target="_blank">Discord</a>. When submitting a bug a staff member puts it on the developer's todo list.</p>
            <hr id="3">
            <h5 class="paragraph--heading">Can I donate with OSGP?</h5>
            <p><strong>Yes</strong> - we accept donations with OSGP through our ticket system via the <a href="https://discord.com/channels/1367631511951769672/1367696662553952266" target="_blank">Discord</a>. </p>
            <hr id="4">
            <h5 class="paragraph--heading">What is the process for becoming a Xalor staff member?</h5>
            <p>You are always welcome to apply to become a staff member! </p>
            <hr id="5">
            <h5 class="paragraph--heading">How do I claim rewards after voting?</h5>
            <p>Votes are automatically claimed upon voting.</p>
            <hr id="6">
            <h5 class="paragraph--heading">How do I claim items purchased from the store?</h5>
            <p>Items are automatically placed in your bank upon making a purchase in (::store)</p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  created() {
    document.title = 'FAQ - Xalor'
  }
}
</script>
